/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-27 19:23:08
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-06-04 15:57:19
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 团长列表
export const partnerList = params => {
	return request({
		url: '/api/partner/list',
		params: params,
		method: AjaxMethod.get,
	});
};

//新增账号
export const addAccount = params => {
	return request({
		url: '/api/account/add',
		data: params,
		method: AjaxMethod.post,
	});
};

//禁用子账号
export const disableAccount = params => {
	return request({
		url: '/api/account/disable',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//启用子账号
export const enableAccount = params => {
	return request({
		url: '/api/account/enable',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//账号重置
export const resetAccount = params => {
	return request({
		url: '/api/account/reset',
		data: params,
		method: AjaxMethod.post,
	});
};

// 子账号编辑
export const accountEdit = params => {
	return request({
		url: '/api/account/edit',
		data: params,
		method: AjaxMethod.post,
	});
};

// 团队配置-获取团队配置
export const getTeamConf = (params, notOrigin = true) => {
	return request({
		url: '/api/team-conf/get-team-material',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 团队配置-检测二级域名
export const checkDomain = params => {
	return request({
		url: '/api/team-conf/check-domain',
		params,
		method: AjaxMethod.get,
	});
};

// 团队配置-设置团队配置
export const setTeamConf = params => {
	return request({
		url: '/api/team-conf/set-team-material',
		data: params,
		method: AjaxMethod.post,
	});
};

// 删除子账户-校验
export const accountCheckDel = params => {
	return request({
		url: '/api/account/check-del',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 删除子账号
export const accountDelete = params => {
	return request({
		url: '/api/account/delete',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
//删除角色
export const deletRole = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-del',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};
//新增/删除用户
export const addAndDeletMembers = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-add-user',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

//获得租户角色
export const getRoleList = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-list',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//获得租户角色成员
export const getRoleMember = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/list-user-roles',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//新增角色获取所有的菜单权限
export const getAllMenuPower = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/menu-list',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//获取角色的菜单权限
export const getRoleMenuPower = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/list-role-resources',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//获得部门管理列表-子账号管理
export const getDeptList = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/list',
		method: AjaxMethod.get,
		params,
		notOrigin,
	});
};
//获取剩余的账号数量
export const getAccount = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/get-user-count',
		method: AjaxMethod.get,
		notOrigin,
	});
};
//获取成员列表
export const getUsersList = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/user-list',
		method: AjaxMethod.get,
		params,
		notOrigin,
	});
};
//删除角色成员列表
export const roleDelUser = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-del-user',
		method: AjaxMethod.get,
		params,
		notOrigin,
	});
};
//用户新增
export const saveAddAccount = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/user-create',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};
//获取部门下拉列表（新增部门中）
export const getDepName = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/dept-all',
		method: AjaxMethod.get,
		notOrigin,
	});
};
//编辑用户
export const subeditAct = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/user-update',
		method: AjaxMethod.put,
		data: params,
		notOrigin,
	});
};
//获取下拉角色列表
export const getRoleDownList = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-list',
		method: AjaxMethod.get,
		notOrigin,
	});
};
// 根据数据权限获取角色能查看的部门信息
export const managerDeptlistByScope = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/dept-list',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};
// 获取多个角色的数据权限合集
export const listRlesMenu = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-menu-list',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};
//获得部门管理列表-部门管理
export const getPartnerList = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/list',
		method: AjaxMethod.get,
		params,
		notOrigin,
	});
};
//编辑用户
export const mobileCheck = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/mobile-check',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};
//用户类型对应达人运营权限
export const checkUserTalentPermission = data => {
	return request({
		url: '/api/team-manage/check-user-talent-permission',
		data,
		method: AjaxMethod.post,
	});
};
//微信解除绑定
export const wxUnbind = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/wx-unbind',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};
// 提成设置
export const achievementSet = params => {
	return request({
		url: '/api/partner/set-commission-rate',
		data: params,
		method: AjaxMethod.post,
	});
};
//删除用户
export const delaccount = (id, notOrigin = true) => {
	return request({
		url: `/admin-api/system/mangerUser/delete?id=${id}`,
		method: AjaxMethod.delete,
		notOrigin,
	});
};
//交接详情-达人
export const relayAnchorDetail = params => {
	return request({
		url: '/api/relay/anchor-detail',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//已交接列表
export const relayList = params => {
	return request({
		url: '/api/relay/relay-list',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//已交接统计
export const relaycount = params => {
	return request({
		url: '/api/relay/relay-count',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//待交接达人列表
export const todoAnchorList = params => {
	return request({
		url: '/api/relay/anchor-list',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//交接-待交接商品列表
export const todoProductList = params => {
	return request({
		url: '/api/relay/product-list',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//交接-待交接团长列表
export const todoInstitutionList = params => {
	return request({
		url: '/api/relay/institution-list',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//交接-待交接数量统计
export const relayWaitRelayNum = params => {
	return request({
		url: '/api/relay/wait-relay-num',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//交接达人
export const relayAnchor = params => {
	return request({
		url: '/api/relay/relay-anchor',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//交接-交接团长
export const relayInstitution = params => {
	return request({
		url: '/api/relay/relay-institution',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
//交接-交接店铺
export const relayProduct = params => {
	return request({
		url: '/api/relay/relay-product',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 微信绑定列表
export const wxBindList = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/wx-list',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};
// 重新分配，获取分配到的对象
export const relateToList = params => {
	return request({
		url: '/api/partner/relate-to-list',
		params,
		method: AjaxMethod.get,
	});
};

//删除子部门
export const delSonDep = (id, notOrigin = true) => {
	return request({
		url: `/api/team-manage/delete?id=${id}`,
		method: AjaxMethod.delete,
		notOrigin,
	});
};

//编辑部门
export const editDep = (id, notOrigin = true) => {
	return request({
		url: `/api/team-manage/dept-list?id=${id}`,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//新增部门后保存
export const addDep = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/create',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};

//获取负责人下拉列表（新增部门）
export const getNickList = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/select-user-list',
		method: AjaxMethod.get,
		notOrigin,
	});
};

//编辑部门后保存
export const subEditDep = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/update',
		method: AjaxMethod.put,
		data: params,
		notOrigin,
	});
};

//获取部门负责人变更记录列表
export const deptLeaderRecordList = params => {
	return request({
		url: '/api/team-manage/dept-leader-record-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//修改角色
export const editRole = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-save',
		method: AjaxMethod.put,
		data: params,
		notOrigin,
	});
};
//新增角色
export const addRole = (params, notOrigin = true) => {
	return request({
		url: '/api/team-manage/role-save',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};

// 团长授权列表
export const authorizeList = (params, notOrigin = false) => {
	return request({
		url: '/api/institution/authorize-list',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};

// 新增授权
export const addAuthorize = params => {
	return request({
		url: '/api/institution/add-authorize',
		method: AjaxMethod.get,
		params,
		notOrigin: false,
	});
};

// 开启授权/重新授权
export const startAuthorize = params => {
	return request({
		url: '/api/institution/start-authorize',
		method: AjaxMethod.get,
		params,
		notOrigin: false,
	});
};

// 取消授权
export const closeAuthorize = params => {
	return request({
		url: '/api/institution/close-authorize',
		method: AjaxMethod.get,
		params,
		notOrigin: false,
	});
};

// 删除授权
export const delAuthorize = params => {
	return request({
		url: '/api/institution/del-authorize',
		method: AjaxMethod.get,
		params,
		notOrigin: false,
	});
};

// 已完成授权校验
export const checkState = (params, notOrigin = false) => {
	return request({
		url: '/api/institution/check-state',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};

// 下拉团长团长授权圈列表
export const institutionList = (params, notOrigin = false) => {
	return request({
		url: '/api/institution/search-list',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};

// 下拉团长团长授权圈列表java
export const institutionListJava = (params, notOrigin = true) => {
	const api = process.env.VUE_APP_API_BASE === 'https://test-partner-api' ? '/micro-product-center' : '/micro-product-center-canary';
	return request({
		url: `${api}/sync/inst-status`,
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};

// 设置默认团长
export const institutionSetDefault = (params, notOrigin = false) => {
	return request({
		url: '/api/institution/set-default',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};

// 取消默认团长
export const institutionDelDefault = (params, notOrigin = false) => {
	return request({
		url: '/api/institution/del-default',
		method: AjaxMethod.post,
		data: params,
		notOrigin,
	});
};
// 员工列表
export const commonAllUser = params => {
	return request({
		url: '/api/common/all-user',
		method: AjaxMethod.get,
		params,
	});
};

// 招商运营下拉列表
export const getZsSelectList = params => {
	return request({
		url: '/api/common/user-shop-select',
		method: AjaxMethod.get,
		params,
	});
};

// 达人运营下拉列表
export const getDrSelectList = params => {
	return request({
		url: '/api/common/user-anchor-select',
		method: AjaxMethod.get,
		params,
	});
};

// 视频号店铺授权
export const sphAuthorize = params => {
	return request({
		url: '/api/institution/sph-add-authorize',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 分页获取团长列表
export const getSpInstitutionList = params => {
	return request({
		url: '/api/institution/sph-list-authorize',
		data: params,
		method: AjaxMethod.post,
	});
};

// 设置默认团长 https://yangxuan.w.eolink.com/home/api-studio/inside/xdEADn8ec64dc2dbd8cca7a2cc275b2f8fbf39e0567e399/api/2999045/detail/54449271?spaceKey=yangxuan
export const setSpDefaultInstitution = params => {
	return request({
		url: '/api/institution/sph-set-default',
		data: params,
		method: AjaxMethod.post,
	});
};

// 取消授权 https://yangxuan.w.eolink.com/home/api-studio/inside/xdEADn8ec64dc2dbd8cca7a2cc275b2f8fbf39e0567e399/api/2999045/detail/54449212?spaceKey=yangxuan
export const cancelSpAuthorize = params => {
	return request({
		url: '/api/institution/sph-close-authorize',
		data: params,
		method: AjaxMethod.post,
	});
};